import React, { useState, useContext } from "react";
import "./BuildFreeInterior.css";
import { LanguageContext } from "../../context/LanguageContext";

import InteriorLightBrown from "../../assets/images/buildFree/inter1Car.webp";
import InteriorDarkBlue from "../../assets/images/buildFree/inter2Car.webp";

import ThumbLightBrown from "../../assets/images/buildFree/inter1.webp";
import ThumbDarkBlue from "../../assets/images/buildFree/inter2.webp";

const INTERIORS = [
  { id: 1, name: "Light Brown", carImg: InteriorLightBrown, thumb: ThumbLightBrown },
  { id: 2, name: "Dark Blue", carImg: InteriorDarkBlue, thumb: ThumbDarkBlue },
];

const BuildFreeInterior = ({ onSelect }) => {
  const { texts } = useContext(LanguageContext);
  const t = texts.buildFree || {};
  const interiorLabels = t.interiors || {};

  const [selected, setSelected] = useState(INTERIORS[0]);

  const handleSelect = (i) => {
    setSelected(i);
    onSelect(i);
  };

  return (
    <div className="build-interior">
      <h4 className="interior-title">{t.chooseInterior}</h4>

      <div className="interior-main">
        <div className="interior-display">
          <img src={selected.carImg} className="interior-img" alt="" />
        </div>

        <div className="interior-list">
          {INTERIORS.map((i) => (
            <div
              key={i.id}
              className={`interior-item ${selected.id === i.id ? "active" : ""}`}
              onClick={() => handleSelect(i)}
            >
              <div className="interior-thumb-wrapper">
                <img src={i.thumb} alt="" />
              </div>
              <p className="interior-name">{interiorLabels[i.name] || i.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuildFreeInterior;
